/**
 * @file product-navigation.js
 */
(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.kodakProductNavigation = {
    attach: function (context, settings) {
      once('region-product', '.region-product', context).forEach(function (element) {

        /**
         * Hides and shows the menu and sections
         */
        function hideShowMenu() {
          const navigationWrapper = document.getElementById('product-navigation-wrapper');
          if (navigationWrapper) {
            const sections = document.querySelectorAll('.section-hideable');
            const radios = navigationWrapper.querySelectorAll('input[type="radio"]');
            const menus = navigationWrapper.querySelectorAll('li.product--category');
            [...radios].forEach(function (radio) {
              if (radio.checked) {
                // Show/hide menus
                [...menus].forEach((menu) => {
                  if (menu.id === radio.dataset.target) {
                    menu.classList.add('show-category');
                  } else {
                    menu.classList.remove('show-category');
                  }
                });

                // Show/hide sections
                [...sections].forEach((section) => {
                  if (section.dataset.parent === radio.dataset.target) {
                    section.classList.remove('section-hidden');
                  } else {
                    section.classList.add('section-hidden');
                  }
                });
              }
            })
          }
        }

        // Bind navigation trigger
        const navigationTrigger = element.querySelectorAll('.btn-check');
        if (navigationTrigger) {
          [...navigationTrigger].forEach((trigger) => {
            trigger.addEventListener('click', hideShowMenu);
          });
        }

        let shouldAnimateScroll = true; // Flag to control scroll animation

        // Scroll to top when a product/support button is pressed
        function scrollToMainContent() {
          if (shouldAnimateScroll) {
            const mainContent = $('.region-content');
            if (mainContent.length) {
              if(window.innerWidth > 920 ) {
                $('html, body').animate({
                  scrollTop: mainContent.offset().top - 20
                }, 300);
              } else {
                $('html, body').animate({
                  scrollTop: mainContent.offset().top - 100
                }, 300);
              }
            }
          }
        }

        // Bind navigation trigger
          $('.product-button').on('click', function () {
            hideShowMenu();
            scrollToMainContent();
          });

        // Initialize
        hideShowMenu();


        // Hide Mobile Menu On Link Click
        $('.product--category-items a').on('click', function() {
          $(this).closest('#product-navigation-wrapper').removeClass('nav-fixed');
          $('#product-navigation-wrapper .product-mobile-title').addClass('collapsed');
          $(this).closest('#product-navigation').removeClass('show');
        });

        // Override jumplinking
        $('a[data-anchor]').on('click', function(event) {
          event.preventDefault();

          const targetId = $(this).data('anchor');
          const target = $(`#${targetId}`);



          if (target.length) {
            if(window.innerWidth > 920 ) {
              $('html, body').animate({
                scrollTop: target.offset().top - 120
              }, 300);
            } else {
              $('html, body').animate({
                scrollTop: target.offset().top - 60
              }, 300);
            }
          }
        });

        function productMobile() {
          if ($('.product-mobile-title').hasClass('collapsed')) {
            $('#product-navigation-wrapper').removeClass('nav-fixed');
            $('.region-product').css('z-index', '9');
          }
          else {
            $('#product-navigation-wrapper').addClass('nav-fixed');
            $('.region-product').css('z-index', '99');
          }
        }

        $('.product-mobile-title').click(function (){
          productMobile();
        });

        $(window).on('scroll', function () {
          let currentHighlight = ''; // Reset the highlight variable on each scroll event
          let closestDistance = Infinity; // Track the closest distance to the top

          $('.paragraph').each(function () {
            let $paragraph = $(this);
            let paragraphTop = $paragraph.offset().top; // Top position of the paragraph
            let scrollTop = $(window).scrollTop() - 100; // Current scroll position
            let windowHeight = $(window).height(); // Height of the viewport
            let paragraphHeight = $paragraph.outerHeight();
            let paragraphBottom = paragraphTop + paragraphHeight;
            let paragraphId = $paragraph.attr('id'); // ID of the paragraph

            // Check if the scroll is within the paragraph's view
            if (typeof paragraphId !== 'undefined' &&
              scrollTop + windowHeight / 2 >= paragraphTop &&
              scrollTop < paragraphBottom - windowHeight / 2) {

              // Calculate the distance from the top of the viewport to the paragraph top
              let distanceToTop = Math.abs(scrollTop - paragraphTop);

              // Update the current highlight if this paragraph is closer
              if (distanceToTop < closestDistance) {
                closestDistance = distanceToTop;
                currentHighlight = paragraphId;
              }
            }
          });

          // Update the active class on anchor links
          $('a[data-anchor]').removeClass('active-section');
          if (currentHighlight) {
            $('a[data-anchor="' + currentHighlight + '"]').addClass('active-section');
          }
        });

        /**
         * Handling deep links
         */

        // Get the hash part from the URL (e.g., #support&videos)
        const hash = window.location.hash.substring(1);

        // Split the hash into button and section (e.g., ["support", "videos"])
        const [buttonName, sectionName] = hash.split("&");

        // If there's a button name in the hash, activate the corresponding button without animation
        if (buttonName) {
          shouldAnimateScroll = false; // Disable animation temporarily
          const $buttonToActivate = $(`input.product-button[data-target="${buttonName}"]`);
          if ($buttonToActivate.length) {
            $buttonToActivate.prop("checked", true).click();
          }
          shouldAnimateScroll = true; // Re-enable animation after handling the hash
        }

        function navigationToMobile() {
          const elements = [
            '#block-kodak-productnavigationblock',
            '#product-navigation-wrapper',
            '.product-button-toggle-wrapper',
            '#product-navigation',
            '.product--category',
            '.product--category-items'
          ];

          if (window.innerWidth <= 1280) {
            elements.forEach(selector => $(selector).addClass('mobile'));
          } else {
            elements.forEach(selector => $(selector).removeClass('mobile'));
          }
        }

        navigationToMobile();

        /**
         * Handling window resizing events
         */

        let previousWindowWidth = window.innerWidth;
        window.addEventListener('resize', function() {

          if(window.innerWidth !== previousWindowWidth) {

            navigationToMobile();
            // Reset Mobile Menu & Remove Screen Lock
            if(window.innerWidth > 1280 ) {
              $('#product-navigation-wrapper').removeClass('nav-fixed');
              $('.product-mobile-title').removeClass('collapsed');
              $('#product-navigation').removeClass('show');
            } else {
              $('.product-mobile-title').addClass('collapsed');
            }
            previousWindowWidth = window.innerWidth;
          }
        });

      });
    }
  };
})(jQuery, Drupal, once);
